import { ref, computed } from '@nuxtjs/composition-api';
import { useTask } from 'vue-concurrency';
import Cookies from 'js-cookie';
import { useDuck } from '~/services';
import { useUser } from '~/composables';
let user = null;
const COOKIE_KEY = 'recom-uuid';
const TEMPORARY_DAY_COOKIE_KEY = 'recom-temporary';
const uuid = ref('');
export function useRecommendationSystem() {
    if (process.server) {
        return;
    }
    if (!uuid.value) {
        user = useUser();
        updateUuid();
    }
    async function sendView(options) {
        const { id, duration, scrollDepth } = options;
        try {
            const { data } = await useDuck().visiting.postVisitingNode({
                node_id: id,
                uuid: uuid.value,
                duration,
                scroll_depth: scrollDepth,
            });
            if (!data?.uuid) {
                console.error('uuid is empty!');
                return;
            }
            const isUserAuthorized = user?.isAuthorized;
            const hasTemporaryCookie = Cookies.get(TEMPORARY_DAY_COOKIE_KEY);
            if (uuid.value && (isUserAuthorized || hasTemporaryCookie)) {
                return;
            }
            if (isUserAuthorized) {
                user?.getCurrentInfo(true);
            }
            else {
                Cookies.set(COOKIE_KEY, uuid.value || data?.uuid, { expires: 30, path: '/' });
                Cookies.set(TEMPORARY_DAY_COOKIE_KEY, 'true', { expires: 1, path: '/' });
            }
            if (!uuid.value) {
                uuid.value = data?.uuid;
                await sendView(options);
            }
        }
        catch (e) {
            console.error('Ошибка в sendView:', e);
            throw e;
        }
    }
    const getArticlesTask = useTask(function* () {
        try {
            const { data } = yield useDuck().recommender.getRecommenderNode({ uuid: uuid.value });
            return data.articles;
        }
        catch (error) {
            console.error(error);
            throw error;
        }
    });
    const isRunningArticlesTask = computed(() => getArticlesTask.isRunning);
    function updateUuid() {
        if (process.server) {
            return;
        }
        uuid.value = user.isAuthorized ? user.clickhouseUuid : Cookies.get(COOKIE_KEY) || '';
    }
    return {
        updateUuid,
        sendView,
        getArticlesTask,
        isRunningArticlesTask,
        get uuid() {
            if (process.server) {
                return;
            }
            return uuid.value;
        },
    };
}
